<mat-card>
  <h2>{{ title | translate }}</h2>
  <mat-card-content>
    <mat-grid-list cols="16" rowHeight="10px">
      <form [formGroup]="selectNameForm" (ngSubmit)="searchForName()" *ngIf="!isNameSelected">
        <mat-grid-tile colspan="6" rowspan="6">
          <mat-form-field fxFlex="100" appearance="outline">
            <mat-label translate>ownPassword.user</mat-label>
            <input id="userRegister" formControlName="name" matInput type="text" autocomplete="off" />
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2" rowspan="6">
          <div fxFlex="100">
            <button
              id="searchRegister"
              color="accent"
              type="submit"
              fxFlex="100"
              mat-flat-button
              [disabled]="acceptButtonDisabled"
            >
              <mat-label translate>button.accept</mat-label>
            </button>
          </div>
        </mat-grid-tile>
      </form>

      <div *ngIf="isNameSelected">
        <mat-grid-tile colspan="16" rowspan="6">
          <div fxFlex="100" fxLayout="column" fxLayoutAlign="center start">
            <mat-label class="user__label"
              ><strong translate>registerWebUser.user</strong> {{ selectedName }}
            </mat-label>
          </div>
        </mat-grid-tile>

        <form [formGroup]="userCharacteristicsForm" (ngSubmit)="registerUser()">
          <mat-grid-tile colspan="6" rowspan="6">
            <scf-custom-select-search
              fxFlex="100"
              formControlName="userType"
              [id]="'userTypeRegister'"
              [dataInput]="userTypeList"
              [placeholder]="'registerWebUser.userType'"
              [isRequired]="true"
              [showErrors]="userCharacteristicsForm?.controls?.userType?.errors"
              (selectionChange)="resetCombos()"
            ></scf-custom-select-search>
          </mat-grid-tile>

          <div *ngIf="isUser; else showBankType">
            <mat-grid-tile colspan="4" rowspan="6">
              <scf-custom-select-search
                fxFlex="100"
                formControlName="divisionType"
                [id]="'divisionTypeRegister'"
                [dataInput]="userDivisionList"
                [placeholder]="'createUser.division'"
                [isRequired]="true"
                [showErrors]="userCharacteristicsForm?.controls?.divisionType?.errors"
                (selectionChange)="loadExternalCommercials()"
              ></scf-custom-select-search>
            </mat-grid-tile>

            <mat-grid-tile colspan="6" rowspan="6">
              <scf-custom-select-search
                fxFlex="100"
                formControlName="externalComercial"
                [id]="'externalComercialRegister'"
                [dataInput]="externalComercialList"
                [placeholder]="'createUser.externalComercial'"
                [isRequired]="true"
                [showErrors]="userCharacteristicsForm?.controls?.externalComercial?.errors"
              ></scf-custom-select-search>
            </mat-grid-tile>
          </div>

          <ng-template #showBankType>
            <mat-grid-tile colspan="2" rowspan="6">
              <scf-custom-select-search
                fxFlex="100"
                formControlName="bankType"
                [id]="'bankTypeRegister'"
                [dataInput]="bankTypeList"
                [placeholder]="'registerWebUser.bankType'"
                [isRequired]="true"
                [showErrors]="userCharacteristicsForm?.controls?.bankType?.errors"
              ></scf-custom-select-search>
            </mat-grid-tile>

            <mat-grid-tile colspan="7" rowspan="6"></mat-grid-tile>
          </ng-template>

          <mat-grid-tile colspan="7" rowspan="6">
            <mat-form-field fxFlex="100" fxLayout="column" fxLayoutAlign="center stretch" appearance="outline">
              <mat-label *ngIf="!isUser; else showDynamicName" translate>registerWebUser.name</mat-label>
              <ng-template #showDynamicName>
                <mat-label>{{ dynamicName }}</mat-label>
              </ng-template>
              <input id="nameRegister" formControlName="user" matInput type="text" autocomplete="off" />
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile colspan="1" rowspan="6">
            <button
              color="accent"
              id="openDialogRegister"
              mat-stroked-button
              type="button"
              (click)="openDialog()"
              [disabled]="isSearchButtonDisabled"
              *ngIf="isCommercial || isUser"
            >
              <mat-icon class="icon-ic_search"></mat-icon>
            </button>
          </mat-grid-tile>

          <div *ngIf="isUser">
            <mat-grid-tile colspan="7" rowspan="6">
              <mat-form-field fxFlex="100" fxLayout="column" fxLayoutAlign="center stretch" appearance="outline">
                <mat-label translate>createUser.impersonatedUser</mat-label>
                <input
                  id="impersonatedUser"
                  #impersonatedUser
                  formControlName="impersonatedUser"
                  matInput
                  type="text"
                  autocomplete="off"
                />
              </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile colspan="1" rowspan="6">
              <button
                color="accent"
                id="openDialogImpersonatedUser"
                mat-stroked-button
                type="button"
                [disabled]="isSearchButtonDisabled"
                (click)="openDialog()"
              >
                <mat-icon class="icon-ic_search"></mat-icon>
              </button>
            </mat-grid-tile>
          </div>

          <mat-grid-tile colspan="6" rowspan="6" *ngIf="isSellerSelected">
            <scf-custom-select-search
              fxFlex="100"
              formControlName="seller"
              [id]="'sellerRegister'"
              [dataInput]="profileList"
              [placeholder]="'createUser.sellers'"
              [isRequired]="true"
              [showErrors]="userCharacteristicsForm?.controls?.seller?.errors"
            ></scf-custom-select-search>
          </mat-grid-tile>

          <mat-grid-tile *ngIf="!isUser || isSellerSelected" colspan="6" rowspan="6"> </mat-grid-tile>

          <mat-grid-tile colspan="8" rowspan="6">
            <!-- <mat-form-field fxFlex="100" appearance="outline">
              <mat-label translate>registerWebUser.profile</mat-label>
              <mat-select id="profileRegister" formControlName="profile">
                <mat-option
                  *ngFor="let option of profileList"
                  [value]="option.id"
                  (onSelectionChange)="comboPerfilSelection()"
                  >{{ option.value }}</mat-option
                >
              </mat-select>
              <mat-error *ngIf="userCharacteristicsForm.controls.profile.hasError('required')" translate>
                field.required
              </mat-error>
            </mat-form-field> -->

            <scf-custom-select-search
              fxFlex="100"
              formControlName="profile"
              [id]="'profileRegister'"
              [dataInput]="profileList"
              [placeholder]="'registerWebUser.profile'"
              [isRequired]="true"
              (selectionChange)="comboPerfilSelection()"
              [showErrors]="userCharacteristicsForm?.controls?.profile?.errors"
            ></scf-custom-select-search>
          </mat-grid-tile>

          <mat-grid-tile *ngIf="!isUser" colspan="6" rowspan="6"> </mat-grid-tile>

          <mat-grid-tile colspan="8" rowspan="6" *ngIf="isUser">
            <scf-custom-select-search
              fxFlex="100"
              formControlName="brand"
              [id]="'brand'"
              [dataInput]="profileList"
              [placeholder]="'create.brand'"
              [isRequired]="true"
              [showErrors]="userCharacteristicsForm?.controls?.brand?.errors"
            ></scf-custom-select-search>
          </mat-grid-tile>

          <!-- <mat-grid-tile colspan="10" rowspan="6" *ngIf="!hasLoadedAtributions()"></mat-grid-tile> -->

          <mat-grid-tile colspan="16" [rowspan]="checkboxRows()" *ngIf="hasLoadedAtributions()">
            <div fxFlex="75" fxLayout="column" formGroupName="atributions" class="atribution-box">
              <mat-label class="atribution-box-title"><strong translate>edit.atribution</strong></mat-label>
              <div fxFlex="100" fxLayout="row wrap">
                <div fxFlex="32" *ngFor="let atribution of atributionsList">
                  <mat-checkbox
                    fxFlex="100"
                    id="atribution{{ atribution.atributionNumber }}RegisterWebUser"
                    color="accent"
                    [formControlName]="atribution.index"
                  >
                    {{ atribution.atributionName }}
                  </mat-checkbox>
                </div>
              </div>
            </div>
          </mat-grid-tile>

          <!-- aqui van todos los campos que aparecen despues de haber seleccionado un ususario de los del librito -->

          <mat-grid-tile colspan="6" rowspan="6" *ngIf="isUserSelected">
            <mat-form-field fxFlex="100" fxLayout="column" fxLayoutAlign="center stretch" appearance="outline">
              <mat-label translate>registerWebUser.division</mat-label>
              <input
                id="divisionRegisterWebUser"
                #divisionRegisterWebUser
                formControlName="division"
                matInput
                type="text"
                autocomplete="off"
              />
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile colspan="6" rowspan="6" *ngIf="isUserSelected">
            <mat-form-field fxFlex="100" fxLayout="column" fxLayoutAlign="center stretch" appearance="outline">
              <mat-label translate>registerWebUser.registerDate</mat-label>
              <input
                id="registerDateRegisterWebUser"
                #registerDateRegisterWebUser
                formControlName="registerDate"
                matInput
                type="text"
                autocomplete="off"
              />
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile colspan="16" rowspan="6" *ngIf="isUserSelected">
            <mat-form-field fxFlex="100" fxLayout="column" fxLayoutAlign="center stretch" appearance="outline">
              <mat-label translate>registerWebUser.description</mat-label>
              <input
                id="descriptionRegisterWebUser"
                #descriptionRegisterWebUser
                formControlName="description"
                matInput
                type="text"
                autocomplete="off"
              />
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile colspan="6" rowspan="6" *ngIf="isUserSelected">
            <mat-form-field fxFlex="100" fxLayout="column" fxLayoutAlign="center stretch" appearance="outline">
              <mat-label translate>registerWebUser.nifCif</mat-label>
              <input
                id="nifcifRegisterWebUser"
                #nifcifRegisterWebUser
                formControlName="nifcif"
                matInput
                type="text"
                autocomplete="off"
              />
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile colspan="6" rowspan="6" *ngIf="isUserSelected">
            <mat-form-field fxFlex="100" fxLayout="column" fxLayoutAlign="center stretch" appearance="outline">
              <mat-label translate>registerWebUser.contactPhone</mat-label>
              <input
                id="phoneRegisterWebUser"
                #phoneDateRegisterWebUser
                formControlName="phone"
                matInput
                type="text"
                autocomplete="off"
              />
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile colspan="16" rowspan="6" *ngIf="isUserSelected">
            <mat-form-field fxFlex="100" fxLayout="column" fxLayoutAlign="center stretch" appearance="outline">
              <mat-label translate>registerWebUser.email</mat-label>
              <input
                id="emailRegisterWebUser"
                #emailRegisterWebUser
                formControlName="email"
                matInput
                type="text"
                autocomplete="off"
              />
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile colspan="16" rowspan="6" *ngIf="isUserSelected">
            <mat-form-field fxFlex="100" fxLayout="column" fxLayoutAlign="center stretch" appearance="outline">
              <mat-label translate>registerWebUser.nameAddress</mat-label>
              <input
                id="addressRegisterWebUser"
                #addressRegisterWebUser
                formControlName="address"
                matInput
                type="text"
                autocomplete="off"
              />
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile colspan="6" rowspan="6" *ngIf="isUserSelected">
            <mat-form-field fxFlex="100" fxLayout="column" fxLayoutAlign="center stretch" appearance="outline">
              <mat-label translate>registerWebUser.population</mat-label>
              <input
                id="townRegisterWebUser"
                #townRegisterWebUser
                formControlName="town"
                matInput
                type="text"
                autocomplete="off"
              />
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile colspan="6" rowspan="6" *ngIf="isUserSelected">
            <mat-form-field fxFlex="100" fxLayout="column" fxLayoutAlign="center stretch" appearance="outline">
              <mat-label translate>registerWebUser.province</mat-label>
              <input
                id="provinceRegisterWebUser"
                #provinceRegisterWebUser
                formControlName="province"
                matInput
                type="text"
                autocomplete="off"
              />
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile colspan="2" rowspan="6" *ngIf="isUserSelected">
            <mat-form-field fxFlex="100" fxLayout="column" fxLayoutAlign="center stretch" appearance="outline">
              <mat-label translate>registerWebUser.postalCode</mat-label>
              <input
                id="postalCodeRegisterWebUser"
                #postalCodeRegisterWebUser
                formControlName="postalCode"
                matInput
                type="text"
                autocomplete="off"
              />
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile colspan="6" rowspan="6">
            <mat-form-field fxFlex="100" fxLayout="column" fxLayoutAlign="center stretch" appearance="outline">
              <mat-label translate>registerWebUser.newPassword</mat-label>
              <input
                id="passwordRegisterWebUser"
                #passwordRegisterWebUser
                formControlName="password"
                matInput
                type="password"
                autocomplete="off"
              />
              <mat-error *ngIf="userCharacteristicsForm.controls.password.hasError('required')" translate>
                field.required
              </mat-error>
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile colspan="2" rowspan="6">
            <div fxFlex="100" class="create-button">
              <button
                id="createUserRegisterWebUser"
                color="accent"
                type="submit"
                fxFlex="100"
                mat-flat-button
                [disabled]="createUserButtonDisabled"
              >
                <mat-label translate>registerWebUser.createUser</mat-label>
              </button>
            </div>
          </mat-grid-tile>
        </form>
      </div>
    </mat-grid-list>
  </mat-card-content>
</mat-card>
